import React, { useEffect } from 'react';
import withPage from '../withPage';
import { useDispatch, useSelector } from 'react-redux';
import { Card, CardContent, CardHeader, CardTitle } from '../../ui/card';
import { Button } from '../../ui/button';
import { Edit, Building2, Plus } from 'lucide-react';
import { AppDispatch, RootState } from '../../../redux/store';
import { doGetCarriers } from '../../../modules/carriers/stores/thunk';
import { selectAllCarriers } from '../../../modules/carriers/stores/slice';
import { Carrier } from './carrier.types';
import { Skeleton } from '../../ui/skeleton';
import moment from 'moment';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

const CarriersPage = () => {
  const dispatch = useDispatch<AppDispatch>();
  const history = useHistory();

  // Redux state
  const carriers: Carrier[] = useSelector((state: RootState) => selectAllCarriers(state));
  const isFetching = useSelector((state: any) => state.carriers.isFetching);

  // Fetch carriers on component mount
  useEffect(() => {
    dispatch(doGetCarriers({}));
  }, [dispatch]);

  // Format date
  const formatDate = (dateString: string | Date) => {
    return moment(dateString).format('MMM DD, YYYY');
  };

  return (
    <div className="container mx-auto py-6 space-y-6">
      {/* Header */}
      <div className="flex flex-col space-y-2">
        <h1 className="text-3xl font-bold tracking-tight">Carriers</h1>
        <p className="text-muted-foreground">Manage the carriers and their integrations and delivery areas</p>
      </div>

      {/* Add New Carrier Button */}
      <div className="flex justify-end">
        <Button className="flex items-center gap-2">
          <Plus className="h-4 w-4" />
          Add Carrier
        </Button>
      </div>

      {/* Carriers Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
        {isFetching ? (
          // Loading skeletons
          Array.from({ length: 8 }, (_, index) => (
            <Card key={index} className="hover:shadow-md transition-shadow">
              <CardHeader className="pb-3">
                <div className="flex items-center space-x-3">
                  <Skeleton className="h-12 w-12 rounded" />
                  <div className="space-y-2">
                    <Skeleton className="h-4 w-24" />
                    <Skeleton className="h-3 w-16" />
                  </div>
                </div>
              </CardHeader>
              <CardContent className="pt-0">
                <Skeleton className="h-3 w-20 mb-2" />
                <Skeleton className="h-3 w-16" />
              </CardContent>
            </Card>
          ))
        ) : carriers.length === 0 ? (
          // Empty state
          <div className="col-span-full">
            <Card className="text-center py-12">
              <CardContent>
                <Building2 className="h-12 w-12 text-muted-foreground mx-auto mb-4" />
                <h3 className="text-lg font-semibold mb-2">No carriers found</h3>
                <p className="text-muted-foreground mb-4">Get started by adding your first carrier</p>
                <Button>
                  <Plus className="h-4 w-4 mr-2" />
                  Add Your First Carrier
                </Button>
              </CardContent>
            </Card>
          </div>
        ) : (
          // Carrier cards
          carriers.map((carrier: Carrier) => (
            <Card
              key={carrier.id}
              className="hover:shadow-sm transition-shadow cursor-pointer group"
              onClick={() => {
                history.push(`/carriers/${carrier.id}`);
              }}
            >
              <CardHeader className="pb-3">
                <div className="flex items-center space-x-3">
                  <div className="h-12 w-12 rounded-lg bg-muted flex items-center justify-center overflow-hidden">
                    {carrier.logo ? (
                      <img
                        src={carrier.logo}
                        alt={carrier.name}
                        className="h-full w-full object-cover"
                        onError={(e) => {
                          e.currentTarget.style.display = 'none';
                          e.currentTarget.nextElementSibling?.classList.remove('hidden');
                        }}
                      />
                    ) : null}
                    <Building2 className="h-6 w-6 text-muted-foreground" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <CardTitle className="text-lg truncate group-hover:text-primary transition-colors">
                      {carrier.name}
                    </CardTitle>
                    <p className="text-sm text-muted-foreground truncate">ID: {carrier.id}</p>
                  </div>
                </div>
              </CardHeader>
              <CardContent className="pt-0">
                {/* <div className="space-y-2">
                  {carrier.carrierName && (
                    <div>
                      <p className="text-sm font-medium text-muted-foreground">Carrier Name</p>
                      <p className="text-sm truncate">{carrier.carrierName}</p>
                    </div>
                  )}
                  <div>
                    <p className="text-sm font-medium text-muted-foreground">Created</p>
                    <p className="text-sm">{formatDate(carrier.createdAt)}</p>
                  </div>
                </div> */}
              </CardContent>
            </Card>
          ))
        )}
      </div>
    </div>
  );
};

export default withPage(CarriersPage);
